/**
 * Default PDF Viewer sample
 */
import * as ReactDOM from "react-dom";
import * as React from "react";
//import "./pdf.component.css";
import { useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  Group,
  Menu,
  Select,
  rem,
  Text,
  Box,
  NumberInput,
  TextInput,
  ScrollArea,
  Stepper,
  Title,
  ThemeIcon,
  Divider,
  SegmentedControl,
  Input,
  Blockquote,
  ActionIcon,
  Drawer,
  List,
  Tabs,
  ComboboxItem,
  Checkbox,
  LoadingOverlay,
  Flex,
  Badge,
  Indicator,
} from "@mantine/core";
import {
  IconAccessPoint,
  IconAdjustments,
  IconArrowLeft,
  IconArrowRight,
  IconAtom,
  IconCaretLeftFilled,
  IconCaretRight,
  IconCaretRightFilled,
  IconCircleCheck,
  IconGripVertical,
  IconKeyboard,
  IconPencil,
  IconPlayerTrackNextFilled,
  IconPlayerTrackPrevFilled,
  IconPlus,
  IconSearch,
  IconSend,
  IconSignature,
  IconSignRight,
  IconTrash,
  IconUserBolt,
  IconWritingSign,
} from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import "./pdf.component.css";

import { IconUpload, IconPhoto, IconX } from "@tabler/icons-react";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { TestModel } from "../../stories/TestModel";
import { useStepSignStore } from "../../store";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import cx from "clsx";
import {
  randomId,
  useDisclosure,
  useHotkeys,
  useListState,
} from "@mantine/hooks";
import classes from "./DndListHandle.module.css";
import { hasLength, isEmail, useForm } from "@mantine/form";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import {
  LocalizationMap,
  Viewer,
  Worker,
  SpecialZoomLevel,
  RenderPage,
  RenderPageProps,
  RenderViewer,
  Tooltip,
  MinimalButton,
  Position,
  Icon,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { ClassAttributes, HTMLAttributes } from "react";
import { Code, JsonInput } from "@mantine/core";
import { useMove } from "@mantine/hooks";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "./Main.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import {
  pageNavigationPlugin,
  RenderCurrentPageLabelProps,
  RenderGoToPageProps,
} from "@react-pdf-viewer/page-navigation";
import { Rnd } from "react-rnd";

import Signature from "@uiw/react-signature";
import { getFilePlugin, RenderDownloadProps } from "@react-pdf-viewer/get-file";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import { TransformToolbarSlot } from "@react-pdf-viewer/toolbar";
import { useNavigate, useParams } from "react-router-dom";
import {
  convertSignType,
  getFormattedDateUTCPlus7,
  repositorySign,
  signTypes,
  signTypesModel,
  workerUrl,
} from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { DocumentModel } from "../../model/DocumentModel";
import { TblDocument } from "../../model/TblDocument";
import {
  findDocumentBySignatureId,
  listColor,
  ListStepSign,
  SignaturePage,
} from "../../model/SignPage";
import { AddLocationSignModel } from "../../model/AddLocationSignModel";
import { isValidEmail } from "../../_base/extension/Extension";
import { getUsersSelect } from "../../const/getSelectApi";
import { get } from "http";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";

type State = {
  x: number;
  y: number;
  width: number;
  height: number;
};
interface PageItem {
  label: string;
  value: string;
  checked: boolean;
  key: number;
}
interface ListValue {
  label: string;
  value: string;
}
function FlowStep() {
  // let viewer: PdfViewerComponent | null;
  const [active, setActive] = useState(0);
  const [handlerSelectType, setHandlerSelectType] = useState<Array<ListValue>>(
    []
  );
  let params = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState<TblDocument>();
  useEffect(() => {
    if (!params.id || Number.parseInt(params.id) < 1) {
      navigate("/method/folders-task");
    } else {
      addLocationSign(Number.parseInt(params.id));
    }
  }, []);

  const addLocationSign = async function (id: number) {
    if (document) return;
    const url = "/api/v1/SignPage/add-location-sign?documentId=" + id;
    const res = await repositorySign.get<MessageResponse<TblDocument>>(url);
    if (res && res.httpStatusCode === 200) {
      if (res.success) {
        const file = res.data?.signedDocument.split("||")[0];
        if (!file) NotificationExtension.Fails("Không tìm được file");
        else {
          const get = file.split("/") ?? "";
          const _file = get[get.length - 1];
          setSelectFile(_file.slice(6));
          setUrlFile(file ?? "");
        }
        setDocument(res.data);
      } else NotificationExtension.Fails(res.message);
    }
  };

  const nextStep = async () => {
    if (formValues.validate().hasErrors) {
      return active;
    }
    if (
      formValues.getValues().listStepSign &&
      formValues.getValues().listStepSign.length > 0
    ) {
      const listStepFrom = formValues.getValues().listStepSign;
      for (let index = 0; index < listStepFrom.length; index++) {
        const element = listStepFrom[index];

        // check xem có trong data hay k
        const getListStep = data.find((x) => x.key === element.key);

        // create
        if (!(getListStep && getListStep.key)) {
          const newDocument: ListStepSign = {
            id: 0,
            key: element.key,
            username: element.username,
            email: `${element.email.toLowerCase()}`,
            numberstep: data.length === 0 ? index + 1 : data.length,
            list: [],
            idsetupstepsign: 0,
            name: element.name,
            typesign: element.typesign,
            typesigncustomer: Number.parseInt(
              element?.typesigncustomer.toString()
            ),
            issign: 0,
            filehistorysign: "",
            vendorid: 0,
          };
          console.log("Add new document: ", newDocument);
          setData([...data, newDocument]);
        }
        // update by element to ListStepSign in data
        else if (getListStep && getListStep.key) {
          const index = data.findIndex((x) => x.key === element.key);
          if (index > -1) {
            const newDocument: ListStepSign = {
              ...data[index],
              username: element.username,
              email: element.email,
              numberstep: element.numberstep,
              name: element.name,
              typesign: element.typesign,
              typesigncustomer: Number.parseInt(
                element?.typesigncustomer.toString()
              ),
            };
            const newData = [...data];
            newData[index] = newDocument;
            setData(newData);
            console.log("Update document: ", newDocument);
          }
        }
      }

      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        // check nếu ListStepSign in data and not in listStepFrom then delete it
        // có trong màn 2 mà không có trong màn 1
        const getListStepForm = listStepFrom.find((x) => x.key === element.key);
        if (!getListStepForm) {
          setData(data.filter((x) => x.key !== element.key));
        }
      }

      setActive((current) => (current < 4 ? current + 1 : current));
      // setDisabledBtn(false);
      setPageCurrent(-1);
      setSelectType("");
      setSelectedItemId("");
    } else NotificationExtension.Fails("Bạn chưa thêm bước ký !");
  };
  const prevStep = () =>
    setActive((current) => (current > 0 ? current - 1 : current));
  const _init: ListStepSign[] = [];
  const [fromValuesTemp, setFromValuesTemp] = useState(_init);

  const formValues = useForm({
    mode: "uncontrolled",
    validateInputOnChange: false,
    initialValues: {
      listStepSign: _init,
    },
    validate: {
      listStepSign: {
        name: (value) => (value.length < 2 ? "Tên bước chưa nhập" : null),
        email: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (handlerSelectType[index]?.label === "2" && !value) {
            return "Chưa nhập email";
          }
          if (handlerSelectType[index]?.label === "2" && !isValidEmail(value)) {
            return "Email không hợp lệ";
          }
          return null;
        },
        phone: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (handlerSelectType[index]?.label === "3" && !value) {
            return "Chưa nhập số điện thoại !";
          }
          return null;
        },
        username: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (
            handlerSelectType[index]?.label === "0" &&
            (!value || value.length < 1)
          ) {
            return "Chưa chọn người xử lý";
          }
          return null;
        },
        typesigncustomer: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (!value) return "Chưa chọn công cụ ký !";
          const _val = Number(value);
          if (_val < 0) {
            return "Chưa chọn công cụ ký !";
          }
          return null;
        },

        typesign: (value, values, path) => {
          if (!value || value.length < 1) return "Chưa chọn loại hình ký !";
          return null;
        },
      },
    },
  });
  const _span = { base: 6, md: 4, lg: 2.4 };
  const _spanTitle = { base: 6, md: 4, lg: 4 };
  function Controls() {
    return (
      <Grid mb={"xs"}>
        <Grid.Col span={_spanTitle}>
          {" "}
          <Title order={6}>Tiêu đề</Title>
          <Input
            key={randomId()}
            value={document?.name}
            disabled
            placeholder="Nhập"
          />
        </Grid.Col>
        <Grid.Col span={_spanTitle}>
          <Title order={6}>Quy trình mẫu</Title>
          <Select
            disabled
            placeholder="Chọn..."
            data={[
              "BBBG TAI SAN _ HACOM BG",
              "BBBG Tài sản Hà Đông",
              "Biên bản họp tiến độ dự án phần mềm",
              "DNTT CƯỚC VIETTEL THANH HÓA",
            ]}
          />
        </Grid.Col>

        <Grid.Col span={_spanTitle}>
          <Flex justify={"end"}>
            <Button
              mt={"23px"}
              onClick={() => {
                const newDocument: ListStepSign = {
                  id: 0,
                  key: randomId(),
                  username: "",
                  email: "",
                  numberstep: formValues.getValues().listStepSign?.length + 1,
                  list: [],
                  idsetupstepsign: 0,
                  name: "",
                  typesign: "0",
                  typesigncustomer: 0,
                  issign: 0,
                  filehistorysign: "",
                  vendorid: 0,
                };
                formValues.insertListItem("listStepSign", newDocument);
              }}
              leftSection={<IconPlus />}
              variant="outline"
            >
              Thêm bước
            </Button>
          </Flex>
        </Grid.Col>
      </Grid>
    );
  }
  // useEffect(() => {
  //   console.log(formValues.getValues().listStepSign);
  // }, [formValues]);
  const [state, handlers] = useListState<TestModel>([]);
  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListUser(filteredData);
    }
  };
  const items = formValues.getValues().listStepSign.map((item, index) => (
    <Draggable key={item.key} index={index} draggableId={item.key}>
      {(provided, snapshot) => (
        <div
          className={cx(classes.item, {
            [classes.itemDragging]: snapshot.isDragging,
          })}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          {/* {GenItem(item)} */}
          <Blockquote
            color={listColor[index]}
            icon={
              <ActionIcon
                size="sm"
                variant="gradient"
                aria-label="ActionIcon the same size as inputs"
              >
                {index + 1}
              </ActionIcon>
            }
            mt="xl"
          >
            <form
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "end",
              }}
              // onSubmit={(e) => {console.log(e)}}
            >
              <Grid>
                <Grid.Col span={_span}>
                  {" "}
                  <TextInput
                    withAsterisk
                    label="Tên bước"
                    placeholder="Nhập..."
                    key={formValues.key(`listStepSign.${index}.name`)}
                    {...formValues.getInputProps(`listStepSign.${index}.name`)}
                  />
                </Grid.Col>

                <Grid.Col span={_span}>
                  {" "}
                  <Select
                    label="Loại hình ký: "
                    withAsterisk
                    placeholder="Nhập..."
                    nothingFoundMessage="Không có dữ liệu"
                    data={signTypesModel.map((x) => ({
                      label: x.label,
                      value: x.value.toString(), // Chuyển đổi value sang string
                    }))}
                    searchable
                    clearable
                    {...formValues.getInputProps(
                      `listStepSign.${index}.typesign`
                    )}
                    key={formValues.key(`listStepSign.${index}.typesign`)}
                    onChange={(e) => {
                      // console.log(formValues.getValues().listStepSign);
                      // setFromValuesTemp(formValues.getValues().listStepSign);
                      const _sign = e?.toString() ?? "0";
                      const updatedHandlerSelectType = [...handlerSelectType]; // Tạo một bản sao của handlerSelectType
                      const element =
                        formValues.getValues().listStepSign[index];
                      const elementIndex = updatedHandlerSelectType.find(
                        (x) => x.value === element.key
                      );

                      if (elementIndex && elementIndex.value.length > 0) {
                        // Đã có trong mảng `handlerSelectType`
                        if (elementIndex.label !== _sign) {
                          updatedHandlerSelectType[index] = {
                            ...updatedHandlerSelectType[index],
                            label: _sign,
                          };
                        }
                      } else {
                        // Thêm mới nếu không tồn tại
                        updatedHandlerSelectType.push({
                          label: _sign,
                          value: element.key,
                        });
                      }
                      setHandlerSelectType(updatedHandlerSelectType);
                    }}
                  />
                </Grid.Col>
                {(handlerSelectType[index]?.label === "0" ||
                  !handlerSelectType[index]) && (
                  <Grid.Col span={_span}>
                    <Select
                      key={formValues.key(`listStepSign.${index}.username`)}
                      label="Người xử lý"
                      withAsterisk
                      placeholder="Chọn..."
                      clearable
                      searchable
                      limit={50}
                      comboboxProps={{
                        transitionProps: {
                          transition: "pop",
                          duration: 200,
                        },
                      }}
                      data={dataListUser.map((item) => {
                        return {
                          label: item.text ?? "",
                          value: String(item.value ?? ""),
                        };
                      })}
                      onClick={async () => {
                        if (!dataListUser || dataListUser.length < 1) {
                          await fetchDataEmployee();
                        }
                        return;
                      }}
                      nothingFoundMessage="Dữ liệu không có !"
                      {...formValues.getInputProps(
                        `listStepSign.${index}.username`
                      )}
                    />
                  </Grid.Col>
                )}
                {handlerSelectType[index]?.label === "1" && (
                  <Grid.Col span={_span}>
                    <Select
                      withAsterisk
                      label="Chức danh"
                      placeholder="Nhập..."
                      key={formValues.key(`listStepSign.${index}.roleid`)}
                      searchable
                      clearable
                      {...formValues.getInputProps(
                        `listStepSign.${index}.roleid`
                      )}
                    />
                  </Grid.Col>
                )}

                {Number.parseInt(handlerSelectType[index]?.label ?? "0") >
                  1 && (
                  <Grid.Col span={_span}>
                    <Select
                      label="Đối tác"
                      placeholder="Nhập..."
                      key={formValues.key(`listStepSign.${index}.vendorid`)}
                      searchable
                      clearable
                      {...formValues.getInputProps(
                        `listStepSign.${index}.vendorid`
                      )}
                    />
                  </Grid.Col>
                )}
                {(handlerSelectType[index]?.label ?? "0") === "2" && (
                  <Grid.Col span={_span}>
                    {" "}
                    <TextInput
                      withAsterisk
                      label="Email"
                      placeholder="Nhập"
                      key={formValues.key(`listStepSign.${index}.email`)}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.email`
                      )}
                    />
                  </Grid.Col>
                )}
                {(handlerSelectType[index]?.label ?? "0") === "3" && (
                  <Grid.Col span={_span}>
                    <TextInput
                      withAsterisk
                      label="Số điện thoại"
                      placeholder="Nhập"
                      key={formValues.key(`listStepSign.${index}.phone`)}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.phone`
                      )}
                    />
                  </Grid.Col>
                )}
                {Number.parseInt(handlerSelectType[index]?.label ?? "0") >
                  1 && (
                  <>
                    {/* <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Ekyc"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.issign`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.issign`,
                          {
                            type: "checkbox",
                          }
                        )}
                      />
                    </Grid.Col>
                    <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Thêm bước"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.addstep`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.addstep`,
                          {
                            type: "checkbox",
                          }
                        )}
                      />
                    </Grid.Col> */}
                    <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        label="Mã số thuế"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.taxcode`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.taxcode`
                        )}
                      />
                    </Grid.Col>
                  </>
                )}

                <Grid.Col span={_span}>
                  <Select
                    key={formValues.key(
                      `listStepSign.${index}.typesigncustomer`
                    )}
                    withAsterisk
                    label="Công cụ ký: "
                    placeholder="Nhập..."
                    nothingFoundMessage="Không có dữ liệu"
                    //  defaultValue={signTypes[0].value.toString()}
                    data={signTypes.map((x) => ({
                      label: x.label,
                      value: x.value.toString(), // Chuyển đổi value sang string
                    }))}
                    {...formValues.getInputProps(
                      `listStepSign.${index}.typesigncustomer`
                    )}
                  />
                </Grid.Col>
                <Grid.Col span={_span}>
                  {" "}
                  <NumberInput
                    key={formValues.key(`listStepSign.${index}.expdate`)}
                    {...formValues.getInputProps(
                      `listStepSign.${index}.expdate`
                    )}
                    label="Quá hạn sau(ngày)"
                    placeholder="Nhập"
                  />
                </Grid.Col>
              </Grid>

              <div {...provided.dragHandleProps} className={classes.dragHandle}>
                <IconGripVertical
                  style={{ width: rem(28), height: rem(28) }}
                  stroke={1.5}
                  color="black"
                />
                <IconTrash
                  style={{
                    marginLeft: "15px",
                    width: rem(28),
                    height: rem(28),
                  }}
                  stroke={1.5}
                  color="black"
                  onClick={() => {
                    const _index = formValues
                      .getValues()
                      .listStepSign.findIndex((x) => x.key === item.key);
                    //  if (_index >= 0) handlers.remove(_index);
                    if (_index >= 0) {
                      formValues.removeListItem("listStepSign", _index);
                    } else
                      NotificationExtension.Fails(
                        "Không tìm thấy bước để xóa !"
                      );
                  }}
                />
              </div>
            </form>
          </Blockquote>
        </div>
      )}
    </Draggable>
  ));

  //
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [userSelect, setUserSelect] = useState<boolean>(false);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (230 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  //new sign
  // luc chot thi map lại vào form value
  const [data, setData] = useState<Array<ListStepSign>>([]);


  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  // const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;
  useEffect(() => {
    console.log("data:", data);
  }, [data]);
  //
  const renderPage: RenderPage = (props: RenderPageProps) => {
    return (
      <>
        {props.canvasLayer.children}
        {props.annotationLayer.children}
        {props.textLayer.children}
        {/* type là duyệt thì không cần hiển thị */}
        {data
          .filter((x) => x.typesigncustomer !== 0)
          .map((doc, index) =>
            doc.list
              .filter((signaturePage) => {
                // console.log("File comparison:", signaturePage.files, urlFile);
                // console.log("check:", signaturePage.files === urlFile);
                return (
                  signaturePage.page === props.pageIndex &&
                  signaturePage.files?.toString() === urlFile
                );
              })
              .map((item, pageIndex) => (
                <Rnd
                  key={item.key}
                  className="signature-step"
                  bounds={boundaryElm}
                  size={{
                    width: item.width,
                    height: item.height,
                  }}
                  position={{
                    x: item.x,
                    y: item.y,
                  }}
                  onDragStop={(e: any, d: any) => {
                    const updatedKy: SignaturePage[] = doc.list.map(
                      (kyPage, kyIndex) => {
                        //  if (kyPage.page === pageCurrent) {
                        if (true) {
                          return {
                            ...kyPage,
                            ...(kyPage.key === item.key && {
                              x:
                                d.x + kyPage.width > props.width
                                  ? props.width - kyPage.width
                                  : d.x < 0
                                  ? 0
                                  : d.x,
                              y:
                                d.y + kyPage.height > props.height
                                  ? props.height - kyPage.height
                                  : d.y < 0
                                  ? 0
                                  : d.y,
                            }),
                          };
                        }
                        return kyPage;
                      }
                    );
                    const _res = data.map((d) =>
                      d.key === doc.key ? { ...d, list: updatedKy } : d
                    );
                    setData(_res);

                    // setData(
                    //   data.map((d) =>
                    //     d.key === doc.key ? { ...d, list: updatedKy } : d
                    //   )
                    // );
                  }}
                  onResize={(e, direction, ref, delta, position) => {
                    const updatedKy: SignaturePage[] = doc.list.map(
                      (kyPage, kyIndex) =>
                        //   kyPage.page === pageIndex + 1
                        true
                          ? {
                              ...kyPage,
                              ...(kyPage.key === item.key && {
                                with: ref.offsetWidth,
                                height: ref.offsetHeight,
                                ...position,
                              }),
                            }
                          : kyPage
                    );
                    const _res = data.map((d) =>
                      d.key === doc.key ? { ...d, list: updatedKy } : d
                    );
                    setData(_res);
                    // setData(
                    //   data.map((d) =>
                    //     d.key === doc.key ? { ...d, list: updatedKy } : d
                    //   )
                    // );
                  }}
                  onClick={() => {
                  //  console.log(props.height,props.width)
                    if (item.key !== selectedItemId) {
                      setSelectedItemId(item.key);
                      var check = findDocumentBySignatureId(
                        data,
                        selectedItemId
                      );
                      if (check && check.page !== pageCurrent) {
                        setPageCurrent(check.page);
                      }

                      const getSignPage = data.find(
                        (x) =>
                          x.list.findIndex((xx) => xx.key === item.key) !== -1
                      );
                      if (getSignPage) {
                        setSelectedLibrary(getSignPage.key);
                      }

                      const getTypeSelect = convertSignType(
                        getSignPage?.typesigncustomer || -1
                      );
                      setSelectType(getTypeSelect);
                    }
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "10px",
                    justifyContent: "center",
                    border:
                      selectedItemId === item.key
                        ? "solid 3.5px #228be6"
                        : "solid 1px #228be6",
                    background: "#fff",
                    color: "#228be6",
                    fontWeight: "bold",
                    fontSize: "12px",
                    zIndex: 9999,
                  }}
                >
                  <ActionIcon
                    onClick={() => {
                      const filteredData = data.map((document) => ({
                        ...document,
                        list: document.list.filter(
                          (signature) => signature.key !== item.key
                        ),
                      }));
                      setData(filteredData);
                    }}
                    size={"xs"}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                    }}
                    variant="filled"
                    color="red"
                    aria-label="Settings"
                  >
                    <IconX stroke={1.5} />
                  </ActionIcon>{" "}
                  {`Bước ${doc.numberstep}: ${convertSignType(
                    doc.typesigncustomer
                  )}  `}
                </Rnd>
              ))
          )}
      </>
    );
  };
  const [pageCurrent, setPageCurrent] = useState<number>(-1);
  const [pageTotal, setPageTotal] = useState<number>(1);

  const [stateSign, setStateSign] = useState<State>({
    width: 120,
    height: 70,
    x: 0,
    y: 0,
  });
  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  //
  const [selectedLibrary, setSelectedLibrary] = useState<string | null>(); // Quản lý giá trị Select
  const [selectType, setSelectType] = useState<string>("");
  const [selectFile, setSelectFile] = useState<string>();

  const handleAddStep = (
    userNameSelect: string,
    type: number,
    pageNumber: number,
    x: number = stateSign.x,
    y: number = stateSign.y,
    w: number = stateSign.width,
    h: number = stateSign.height
  ) => {
    if (
      !urlFile ||
      urlFile.length < 6 ||
      !document?.signedDocument.split("||").find((x) => x.includes(urlFile)) ||
      selectFile === undefined
    ) {
      NotificationExtension.Fails("Không tìm thấy file !");
      return;
    }
    // pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    const getUserSelect = formValues
      .getValues()
      .listStepSign.find((item) => item.key === userNameSelect);
    if (getUserSelect) {
      const _sign: SignaturePage = {
        key: randomId(),
        x: x,
        y: y,
        width: w,
        height: h,
        page: pageNumber,
        id: 0,
        files: urlFile,
        namefilefrist: selectFile ?? "",
      };
      const existingDocumentIndex = data.findIndex(
        (doc) => doc.key === userNameSelect
      );
      //note: type >0 thì mới tạo vị trí để ký
      // kiểu duyệt không cần update hay thêm gì cả
      if (existingDocumentIndex !== -1) {
        // Nếu đã tồn tại userNameSelect
        const updatedDocuments = data.map((doc, index) => {
          if (index === existingDocumentIndex) {
            const pageIndex = doc.list.findIndex(
              (page) => page.page === pageNumber
            ); // Kiểm tra page 1 đã tồn tại

            if (pageIndex !== -1) {
              console.log("Page found: ", pageNumber);
              let update: Array<SignaturePage> = doc.list;
              if (type > 0)
                doc.list.forEach((signaturePage, idx) => {
                  if (idx === pageIndex) {
                    update.push(_sign);
                    return;
                  }
                });
              const _res: ListStepSign = {
                ...doc,
                typesigncustomer: type,
                list: type === 0 ? doc.list : update,
              };
              return _res;
            } else {
              console.log("Page not found: ", pageNumber);
              const _updated: SignaturePage = {
                page: pageNumber,
                id: _sign.id,
                x: _sign.x,
                y: _sign.y,
                width: _sign.width,
                height: _sign.height,
                key: _sign.key,
                files: _sign.files,
                namefilefrist: _sign.namefilefrist,
              };
              const _res: ListStepSign = {
                ...doc,
                typesigncustomer: type,
                list: type === 0 ? doc.list : [...doc.list, _updated],
              };

              return _res;
            }
          }
          return doc;
        });
        console.log("Update new document: ", updatedDocuments);
        setData(updatedDocuments);
      } else {
        // Nếu chưa tồn tại selectedLibrary, tạo Document mới
        const newDocument: ListStepSign = {
          id: 0,
          key: getUserSelect.key,
          username: getUserSelect.username,
          email: getUserSelect.email ? getUserSelect.email.toLowerCase() : "",

          numberstep: getUserSelect.numberstep,
          list: type === 0 ? [] : [_sign],
          idsetupstepsign: 0,
          name: getUserSelect.name,
          typesign: getUserSelect.typesign,
          typesigncustomer: type,
          issign: 0,
          filehistorysign: "",
          vendorid: 0,
        };
        console.log("Add new document: ", newDocument);
        setData([...data, newDocument]);
      }
    } else {
      NotificationExtension.Info("Bạn chưa chọn người ký !");
      setSelectType("");
    }
  };

  const [initialValues, setInitialValues] = useState<PageItem[]>([]);
  useEffect(() => {
    let init: PageItem[] = [];
    if (pageTotal > 0) {
      for (let index = 0; index < pageTotal; index++) {
        init.push({
          label: "Trang " + (index + 1),
          value: index.toString(),
          checked: false,
          key: index,
        });
      }
      setInitialValues(init);
      handlersCheckbox.setState(init);
    }
  }, [pageTotal]);

  const [values, handlersCheckbox] = useListState(initialValues);

  const allChecked = values.every((value) => value.checked);
  const indeterminate = values.some((value) => value.checked) && !allChecked;
  const itemCheckboxs = values.map((valueCheckbox, index) => (
    <Checkbox
      mt="xs"
      ml={33}
      disabled={selectedItemId == null}
      label={valueCheckbox.label}
      key={valueCheckbox.key}
      checked={valueCheckbox.checked}
      onChange={async (event) => {
        var getListStepSign = data.find(
          (x) => x.list.filter((xx) => xx.key === selectedItemId).length > 0
        );
        var getSign = findDocumentBySignatureId(data, selectedItemId);
        const _page = Number.parseInt(valueCheckbox.value);
        if (getSign && getListStepSign)
          if (event.currentTarget.checked) {
            if (getSign) {
              const _s = getSign;
              handleAddStep(
                getListStepSign.key,
                getListStepSign.typesigncustomer,
                _page,
                _s.x,
                _s.y,
                _s.width,
                _s.height
              );
              handlersCheckbox.setItemProp(index, "checked", true);
            }
          } else {
            const filteredData = data.map((document) => ({
              ...document,
              list: document.list.filter(
                (signature) =>
                  (document.username !== getListStepSign?.username ||
                    signature.page !== _page) &&
                  signature.namefilefrist !== getSign?.namefilefrist
              ),
            }));
            setData(filteredData);
            handlersCheckbox.setItemProp(index, "checked", false);
          }
        else {
          NotificationExtension.Fails("chữ ký bạn chọn đã bị xóa !");
        }
      }}
    />
  ));

  const [resize, SetResize] = useState<any>();

  const [valueTabs, setValueTabs] = useState<string | null>("type");

  const bears = useStepSignStore();
  const [visible, setVisible] = useState(false);

  useHotkeys([
    [
      "Delete",
      () => {
        const filteredData = data.map((document) => ({
          ...document,
          list: document.list.filter(
            (signature) => signature.key !== selectedItemId
          ),
        }));
        setData(filteredData);
      },
    ],
  ]);
  const [stateColor, setStateColor] = useState<string>(listColor[0]);
  useEffect(() => {
    setStateColor(listColor[Number.parseInt(selectedLibrary ?? "0")]);
  }, [selectedLibrary]);

  //new

  const [urlFile, setUrlFile] = useState<string>("");

  /**
   * Hàm chuyển đổi giá trị số thành chuỗi tương ứng
   * @param value Giá trị đầu vào dạng số
   * @returns Chuỗi tương ứng với giá trị số đầu vào
   */

  const _gridType = { base: 6, md: 6, lg: 6, xl: 3 };

  // const [disabledBtn, setDisabledBtn] = useState(false);
  // useEffect(() => {
  //   if (disabledBtn) setDisabledBtn(false);
  // }, [pageCurrent]);
  return (
    <>
      {document && (
        <Box pos="relative">
          <LoadingOverlay
            visible={visible}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 2 }}
          />
          <div
            style={{
              // float: "inline-end",
              // position: "absolute",
              // bottom: "-20px",
              // right: 0,
              // width: "100%",
              // background: "white",
              marginBottom: "10px",
              zIndex: 999,
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "16px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Group>
              <Flex justify={"space-between"} align={"center"}>
                <Badge size="xs" circle mr={"xs"}></Badge> Tổng số bước ký:{" "}
                {formValues.getValues().listStepSign.length}
              </Flex>
              <Flex justify={"space-between"} align={"center"}>
                <Badge size="xs" circle mr={"xs"}></Badge> Tổng số chữ ký:{" "}
                {data.reduce((sum, item) => sum + item.list.length, 0)}
              </Flex>
              <Flex justify={"space-between"} align={"center"}>
                <Badge size="xs" circle mr={"xs"}></Badge> Danh sách bước phê
                duyệt:{" "}
                {data.filter((x) => x.typesigncustomer === 0 && x.list).length}
              </Flex>
            </Group>
            <Group>
              <Button
                leftSection={<IconArrowLeft />}
                mr={"xs"}
                size="xs"
                variant="default"
                onClick={prevStep}
              >
                Quay lại
              </Button>
              {active < 1 && (
                <Button
                  size="xs"
                  rightSection={<IconArrowRight />}
                  onClick={async () => {
                    if (active !== 2) nextStep();
                    else {
                      setVisible(true);
                      const get = formValues.getValues().listStepSign;
                      if (get && get.length > 0) {
                        nextStep();
                        setVisible(false);
                      } else {
                        NotificationExtension.Fails("Bạn chưa thêm chữ ký !");
                        setVisible(false);
                      }
                    }
                  }}
                >
                  Tiếp theo
                </Button>
              )}
              {active >= 1 && (
                <Button
                  size="xs"
                  rightSection={<IconSend />}
                  onClick={async () => {
                    if (
                      formValues.isValid() &&
                      formValues.getValues().listStepSign &&
                      formValues.getValues().listStepSign.length > 0
                    ) {
                      let entity: AddLocationSignModel = {
                        setupstepsign: {
                          id: 0,
                          documentId: document.id,
                          title: document.name,
                          fileUrl: "",
                          createBy: "",
                          lastUpdateBy: "",
                          list: [],
                        },
                        listStepSignModels: [],
                        sampId: 0,
                      };

                      formValues
                        .getValues()
                        .listStepSign.forEach((x, index) => {
                          let _getListStep = data.find((y) => y.key === x.key);
                          if (_getListStep) {
                            _getListStep.numberstep = index + 1;
                            entity.listStepSignModels.push({
                              listStepsign: _getListStep,
                              signaturePages: _getListStep.list,
                            });
                          }
                        });
                      const url = "/api/v1/SignPage/add-location-sign";
                      const result = await repositorySign.post<
                        MessageResponse<boolean>
                      >(url, entity);
                      if (result && result.httpStatusCode === 200) {
                        if (result.success) {
                          NotificationExtension.Success("Thành công !");
                          setTimeout(() => {
                            navigate("/method/approve-task");
                          }, 2000);
                        } else
                          NotificationExtension.Fails(
                            result.message.length > 0
                              ? result.message
                              : "Thất bại !"
                          );
                      }
                    } else NotificationExtension.Fails("Dữ liệu không đúng !");
                  }}
                >
                  Trình ký
                </Button>
              )}
            </Group>
          </div>
          <div
            style={{
              position: "relative",
              height: "calc(100vh - 150px)",
            }}
          >
            <Stepper active={active} onStepClick={setActive}>
              <Stepper.Step label="Khai báo các bước" description="">
                {Controls()}
                <DragDropContext
                  onDragEnd={({ destination, source }) => {
                    destination?.index !== undefined &&
                      formValues.reorderListItem("listStepSign", {
                        from: source.index,
                        to: destination.index,
                      });
                  }}
                >
                  <Droppable droppableId="dnd-list" direction="vertical">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <ScrollArea h={height}>{items}</ScrollArea>

                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Stepper.Step>
              <Stepper.Step
                label="Thiết lập vị trí ký"
                description="Get full access"
                disabled={!(state && state.length > 0)}
              >
                <Grid>
                  <Grid.Col span={{ base: 4, md: 4, lg: 5, xl: 5 }}>
                    <Select
                      label="Chọn tài liệu"
                      key={randomId()}
                      placeholder="Chọn..."
                      value={selectFile}
                      onChange={(e) => {
                        const _key = e ?? "";
                        setSelectFile(_key);
                        if (_key.length > 0) {
                          const file = document.signedDocument
                            .split("||")
                            .find((x) => x.includes(_key));
                          if (file) setUrlFile(file);
                          //  setDisabledBtn(true);
                          setPageCurrent(-1);
                          setSelectedItemId("");
                        }
                      }}
                      data={document.signedDocument.split("||").map((x) => ({
                        label: x.split("/")[x.split("/").length - 1].slice(6),
                        value: x.split("/")[x.split("/").length - 1].slice(6),
                      }))}
                    />
                    <Select
                      label="Người ký"
                      key={randomId()}
                      placeholder="Chọn..."
                      value={selectedLibrary}
                      onChange={(e) => {
                        setSelectedLibrary(e);
                        const user = data.find(
                          (x) => x.key === e?.toString() && x.list !== undefined
                        );
                        const getTypeSelect = convertSignType(
                          user?.typesigncustomer || -1
                        );
                        setSelectType(getTypeSelect);
                        setSelectedItemId("");
                      }}
                      data={formValues
                        .getValues()
                        .listStepSign.filter((x) => x.name && x.name.length > 0)
                        .map((x) => ({
                          label: "Bước " + x.numberstep + " :" + x.name,
                          value: x.key,
                        }))}
                    />
                    <Tabs
                      color="teal"
                      value={valueTabs}
                      onChange={setValueTabs}
                      defaultValue={valueTabs}
                    >
                      <Tabs.List>
                        <Tabs.Tab value="type">Loại ký</Tabs.Tab>
                        {/* <Tabs.Tab
                        //  disabled={viewer?.annotations?.length>0}
                        value="setting"
                        color="blue"
                      >
                        Cài đặt
                      </Tabs.Tab> */}
                      </Tabs.List>

                      <Tabs.Panel value="type" pt="xs">
                        <Grid>
                          <Grid.Col span={_gridType}>
                            {" "}
                            <Button
                              //   disabled={disabledBtn}
                              w={"100%"}
                              variant={
                                !(selectType === "Duyệt") ? "outline" : "filled"
                              }
                              color={stateColor}
                              leftSection={<IconAccessPoint />}
                              onClick={() => {
                                if (selectType === "Duyệt")
                                  handleAddStep(
                                    selectedLibrary ?? "",
                                    0,
                                    pageCurrent
                                  );
                                setSelectType("Duyệt");
                              }}
                            >
                              {selectType === "Duyệt" ? "" : "Chọn"} Duyệt
                            </Button>
                          </Grid.Col>
                          <Grid.Col span={_gridType}>
                            {" "}
                            <Button
                              //  disabled={disabledBtn}
                              w={"100%"}
                              variant={
                                !(selectType === "Ký ảnh")
                                  ? "outline"
                                  : "filled"
                              }
                              color={stateColor}
                              leftSection={<IconWritingSign />}
                              onClick={() => {
                                if (selectType === "Ký ảnh")
                                  handleAddStep(
                                    selectedLibrary ?? "",
                                    1,
                                    pageCurrent
                                  );
                                setSelectType("Ký ảnh");
                              }}
                            >
                              {selectType === "Ký ảnh" ? "" : "Chọn"} Ký ảnh{" "}
                            </Button>
                          </Grid.Col>
                          <Grid.Col span={_gridType}>
                            {" "}
                            <Button
                              //   disabled={disabledBtn}
                              w={"100%"}
                              variant={
                                !(selectType === "Ký số") ? "outline" : "filled"
                              }
                              color={stateColor}
                              leftSection={<IconAtom />}
                              onClick={() => {
                                if (selectType === "Ký số")
                                  handleAddStep(
                                    selectedLibrary ?? "",
                                    2,
                                    pageCurrent
                                  );
                                setSelectType("Ký số");
                              }}
                            >
                              {selectType === "Ký số" ? "" : "Chọn"} Ký số
                            </Button>
                          </Grid.Col>
                          <Grid.Col span={_gridType}>
                            {" "}
                            <Button
                              //     disabled={disabledBtn}
                              w={"100%"}
                              variant={
                                !(selectType === "Ký nháy")
                                  ? "outline"
                                  : "filled"
                              }
                              color={stateColor}
                              leftSection={<IconSignature />}
                              onClick={() => {
                                if (selectType === "Ký nháy")
                                  handleAddStep(
                                    selectedLibrary ?? "",
                                    3,
                                    pageCurrent
                                  );
                                setSelectType("Ký nháy");
                              }}
                            >
                              {selectType === "Ký nháy" ? "" : "Chọn"} Ký nháy
                            </Button>
                          </Grid.Col>
                        </Grid>

                        <Divider my="md" />

                        <Menu
                          shadow="md"
                          width={"150px"}
                          closeOnItemClick={false}
                        >
                          <Menu.Target>
                            <Button
                              disabled={!selectedItemId}
                              w={"100%"}
                              onClick={() => {
                                const document = data.find((doc) =>
                                  doc.list.some(
                                    (page) => page.key === selectedItemId
                                  )
                                );
                                if (document) {
                                  const userName = document.username;
                                  const pagesForUser = data
                                    .filter(
                                      (doc) =>
                                        doc.key === selectedLibrary &&
                                        doc.typesigncustomer > 0 &&
                                        doc.list.find(
                                          (xx) =>
                                            xx.namefilefrist === selectFile
                                        )
                                    )
                                    .flatMap((doc) => doc.list)
                                    .map((pageNumber) =>
                                      document.list.find(
                                        (page) =>
                                          page.page === pageNumber.page &&
                                          page.namefilefrist === selectFile
                                      )
                                    );
                                  const _page = Array.from(
                                    new Set(
                                      pagesForUser?.map((x) => {
                                        const pageValue = x?.page ?? 0;
                                        return pageValue === 0 ? 0 : pageValue;
                                      })
                                    )
                                  );
                                  handlersCheckbox.setState((current) =>
                                    current.map((value) => ({
                                      ...value,
                                      checked: false,
                                    }))
                                  );
                                  _page.forEach((x) => {
                                    handlersCheckbox.setItemProp(
                                      x,
                                      "checked",
                                      true
                                    );
                                  });
                                } else {
                                  console.log(
                                    "Không tìm thấy SignaturePosition với ID này trong danh sách Documents."
                                  );
                                }
                              }}
                            >
                              Chọn trang ký
                            </Button>
                          </Menu.Target>

                          <Menu.Dropdown>
                            <Menu.Label>Danh sách trang</Menu.Label>
                            <Divider />
                            <ScrollArea mt={"xs"} h={250}>
                              {itemCheckboxs}
                            </ScrollArea>
                          </Menu.Dropdown>
                        </Menu>
                        <Divider my="md" />
                        <Title mt={"xs"} id="text" ta="center" order={6}>
                          Vị trí
                        </Title>
                        <Grid mt={"xs"}>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Tọa độ (X):
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              key={randomId()}
                              value={
                                findDocumentBySignatureId(data, selectedItemId)
                                  ?.x
                              }
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Tọa độ (Y):
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              key={randomId()}
                              value={
                                findDocumentBySignatureId(data, selectedItemId)
                                  ?.y
                              }
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                        </Grid>

                        <Divider my="md" />

                        <Title id="text" ta="center" order={6}>
                          Kích thước
                        </Title>
                        <Grid mt={"xs"}>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Chiều dài:
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              key={randomId()}
                              value={
                                findDocumentBySignatureId(data, selectedItemId)
                                  ?.width
                              }
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Chiều rộng:
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              key={randomId()}
                              value={
                                findDocumentBySignatureId(data, selectedItemId)
                                  ?.height
                              }
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                        </Grid>
                      </Tabs.Panel>

                      <Tabs.Panel value="setting" pt="xs">
                        <Menu
                          shadow="md"
                          width={"250px"}
                          closeOnItemClick={false}
                        >
                          <Menu.Target>
                            <Button
                              disabled={!userSelect}
                              w={"100%"}
                              onClick={() => {}}
                            >
                              Chọn trang ký
                            </Button>
                          </Menu.Target>

                          <Menu.Dropdown>
                            <Menu.Label>Danh sách trang</Menu.Label>
                            <Divider />
                            <ScrollArea mt={"xs"} h={250}>
                              <Checkbox
                                checked={allChecked}
                                indeterminate={indeterminate}
                                label="Tất cả"
                                key={"all"}
                                onChange={() => {
                                  handlersCheckbox.setState((current) =>
                                    current.map((value) => ({
                                      ...value,
                                      checked: !allChecked,
                                    }))
                                  );
                                }}
                              />
                              {itemCheckboxs}
                            </ScrollArea>
                          </Menu.Dropdown>
                        </Menu>

                        <Title mt={"xs"} id="text" ta="center" order={6}>
                          Vị trí
                        </Title>
                        <Grid mt={"xs"}>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Tọa độ (X):
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              //  value={Number.parseInt(location?.x ?? 0)}
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Tọa độ (Y):
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              //  value={Number.parseInt(location?.y ?? 0)}
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                        </Grid>

                        <Divider my="md" />

                        <Title id="text" ta="center" order={6}>
                          Kích thước
                        </Title>
                        <Grid mt={"xs"}>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Chiều dài:
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              key={randomId()}
                              value={Number.parseInt(resize?.height ?? 0)}
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <Title id="text" ta="center" order={6}>
                              Chiều rộng:
                            </Title>
                          </Grid.Col>
                          <Grid.Col span={6}>
                            {" "}
                            <TextInput
                              key={randomId()}
                              value={Number.parseInt(resize?.width ?? 0)}
                              rightSection={<p>px</p>}
                            />
                          </Grid.Col>
                        </Grid>
                      </Tabs.Panel>
                    </Tabs>
                  </Grid.Col>
                  <Grid.Col span={{ base: 8, md: 8, lg: 7, xl: 7 }}>
                    {" "}
                    <div
                      className="rpv-core__viewer"
                      style={{
                        border: "1px solid rgba(0, 0, 0, 0.3)",
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          alignItems: "center",
                          backgroundColor: "#fff",
                          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                          display: "flex",
                          justifyContent: "center",
                          padding: "4px",
                        }}
                      >
                        <div style={{ padding: "0 2px" }}>
                          <GoToFirstPage>
                            {(props: RenderGoToPageProps) => (
                              <ActionIcon
                                onClick={() => {
                                  //  setDisabledBtn(true);
                                  props.onClick();
                                }}
                                variant="filled"
                                aria-label="Settings"
                              >
                                <IconPlayerTrackPrevFilled
                                  style={{
                                    width: "70%",
                                    height: "70%",
                                  }}
                                  stroke={1.5}
                                />
                              </ActionIcon>
                            )}
                          </GoToFirstPage>
                        </div>
                        <div style={{ padding: "0 2px" }}>
                          <GoToPreviousPage>
                            {(props: RenderGoToPageProps) => (
                              <ActionIcon
                                disabled={props.isDisabled}
                                onClick={() => {
                                  //  setDisabledBtn(true);
                                  props.onClick();
                                }}
                                variant="filled"
                                aria-label="Settings"
                              >
                                <IconCaretLeftFilled
                                  style={{
                                    width: "70%",
                                    height: "70%",
                                  }}
                                  stroke={1.5}
                                />
                              </ActionIcon>
                            )}
                          </GoToPreviousPage>
                        </div>
                        <div
                          style={{
                            width: "100px",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <NumberInput
                            style={{
                              width: "50px",
                            }}
                            key="currentPage"
                            id="currentPage"
                            size="xs"
                            value={pageCurrent + 1}
                            hideControls
                            onKeyUp={(e) => {
                              const _v = e.currentTarget.value;
                              if (e.key === "Enter") {
                                // Kiểm tra nếu phím Enter được nhấn
                                const value =
                                  typeof _v === "string"
                                    ? Number.parseInt(_v)
                                    : (e.target as HTMLInputElement)
                                        .valueAsNumber;
                                const h = value > 0 ? value - 1 : 0;
                                jumpToPage(h);
                                //  setDisabledBtn(true);
                                setPageCurrent(h);
                              }
                            }}
                            min={1}
                            max={pageTotal}
                          />{" "}
                          <strong>/{pageTotal}</strong>
                          {/* <CurrentPageLabel>
                            {(props: RenderCurrentPageLabelProps) => (
                              <>{props && <></>}</>
                            )}
                          </CurrentPageLabel> */}
                        </div>

                        <div style={{ padding: "0 2px" }}>
                          <GoToNextPage>
                            {(props: RenderGoToPageProps) => (
                              <ActionIcon
                                disabled={props.isDisabled}
                                onClick={() => {
                                  //     setDisabledBtn(true);
                                  props.onClick();
                                }}
                                variant="filled"
                                aria-label="Settings"
                              >
                                <IconCaretRightFilled
                                  style={{
                                    width: "70%",
                                    height: "70%",
                                  }}
                                  stroke={1.5}
                                />
                              </ActionIcon>
                            )}
                          </GoToNextPage>
                        </div>
                        <div style={{ padding: "0 2px" }}>
                          <GoToLastPage>
                            {(props: RenderGoToPageProps) => (
                              <ActionIcon
                                onClick={() => {
                                  //   setDisabledBtn(true);
                                  props.onClick();
                                }}
                                variant="filled"
                                aria-label="Settings"
                              >
                                <IconPlayerTrackNextFilled
                                  style={{
                                    width: "70%",
                                    height: "70%",
                                  }}
                                  stroke={1.5}
                                />
                              </ActionIcon>
                            )}
                          </GoToLastPage>
                        </div>
                      </div>
                      {active === 1 && (
                        <Group justify="center">
                          <div
                            className="App"
                            ref={(ref) => setBoundaryElm(ref!)}
                          >
                            <Worker workerUrl={workerUrl}>
                              <Viewer
                                localization={
                                  de_DE as unknown as LocalizationMap
                                }
                                fileUrl={urlFile}
                                plugins={[
                                  //  defaultLayoutPluginInstance,
                                  pageNavigationPluginInstance,
                                ]}
                                defaultScale={SpecialZoomLevel.ActualSize}
                                renderPage={renderPage}
                                onPageChange={(e) => {
                                  //   setDisabledBtn(true);
                                  if (pageTotal !== e.doc.numPages)
                                    setPageTotal(e.doc.numPages);
                                  // if (e.currentPage !== pageCurrent) {
                                  setPageCurrent(e.currentPage);
                                  // setDisabledBtn(false);
                                  // }
                                }}
                                // onDocumentLoad={(e) => {
                                //   console.log(
                                //     "Load data : " + JSON.stringify(data)
                                //   );
                                // }}
                              />
                            </Worker>
                          </div>
                        </Group>
                      )}
                    </div>
                  </Grid.Col>
                </Grid>
              </Stepper.Step>
            </Stepper>
          </div>
        </Box>
      )}
      {!document && <>Tài liệu không tồn tại !</>}
    </>
  );
}

export default FlowStep;
